import Box from 'components/shared/Box'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'

export const VoucherInfo = () => {
    const { isMobile, isTablet } = useResolutions()
    return (
        <Box
            direction="row"
            align={['flex-start', 'center']}
            isFullWidth
            bgColor="info_bg"
            gap={16}
            padding={16}
            mb={[16, 24]}
            style={{ borderRadius: '8px' }}
        >
            <Icon variant="tooltip" color="info" />
            <Text variant="bodySmall" color="info">
                {isMobile || isTablet ? (
                    <FormattedMessage
                        id="vouchers.config.info_mobile"
                        defaultMessage="Zwróć uwagę na układ tekstu w podglądzie vouchera poniżej."
                    />
                ) : (
                    <FormattedMessage
                        id="vouchers.config.info"
                        defaultMessage="Zwróć uwagę na układ tekstu w podglądzie vouchera."
                    />
                )}
            </Text>
        </Box>
    )
}
